import { createClient } from '@supabase/supabase-js';

export const supabaseConfig = {
  url: process.env.REACT_APP_SUPABASE_URL || 'https://fxfuvylzbsbbarwfajhm.supabase.co',
  anonKey:
    process.env.REACT_APP_SUPABASE_ANON_KEY ||
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZ4ZnV2eWx6YnNiYmFyd2ZhamhtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njk0MzkwNTQsImV4cCI6MjA4NTAxNTA1NH0.jMKiIQ2JLziX6fN3t6ZuYyEiPWc7-UnOLjwRAZWKrYI',
};

export const supabaseClient = createClient(supabaseConfig.url, supabaseConfig.anonKey);
